module.exports = __webpack_public_path__ + "img/nosort.db882563.svg";